(function () {
    'use strict';

    angular.module('app').controller('PlywoodConfigModalController', PlywoodConfigModalController);
    PlywoodConfigModalController.$inject = [
        '$uibModalInstance',
        'Units',
        'Carrier',
        'toastr',
        'Currency',
        '$q',
        '$routeParams'
    ];

    function PlywoodConfigModalController(
        $uibModalInstance,
        Units,
        Carrier,
        toastr,
        Currency,
        $q,
        $routeParams
    ) {
        const vm = this;
        vm.id = $routeParams.id === 'new' ? false : $routeParams.id || false;
        vm.measureUnits = Units.measureUnit;
        vm.weightUnits = Units.weightUnit;
        vm.currencies = [];
        vm.crateData = {
            dimensionRanges:[{
                min:0,
                max:0,
                priceIncrement:0,
                viewMode:true
            }],
            cubicWeightRanges:[{
                min:0,
                max:0,
                cubicConversionFactor:0,
                viewMode:true
            }]
        };
        vm.isLoading = false;
        vm.closeModal = closeModal;
        vm.addFieldsCrates = addFieldsCrates;
        vm.removeForm = removeForm;
        vm.editMode =editMode;
        vm.save = save;

        init();

        function init() {

            getCurrency().then(() => {
                getCrateDetails();
            });
        }

        function getCrateDetails() {
            Carrier.getCratePlywoodConfig(data => {
                setCrateDetails(data);
            }, error => { });
        }

        function setCrateDetails(data) {
            vm.crateData = angular.copy(data);
            vm.crateData.currency = vm.currencies.find(currency => currency.currencyCode == data.currency);
            vm.crateData.measureUnit = vm.measureUnits.find(unit => unit.short == data.measureUnit);
            vm.crateData.weightUnit =  vm.weightUnits.find(unit=>unit.value == data.weightUnit);
        }

        function getCurrency() {
            const defer = $q.defer();

            Currency.getList((data) => {
                vm.currencies = data;
                defer.resolve(data);
            });

            return defer.promise;
        }

        function closeModal() {
            $uibModalInstance.close();
        }

        function save(crateForm) {
            if (crateForm.$invalid) { return; }
            if (vm.crateData.id) {
                updateConfig();
                return;
            }

            createConfig();
        }

        function updateConfig() {
            vm.isLoading = true;
            Carrier.updateCratePlywoodConfig(generatePayload(), (data) => {
                vm.crateData = data;
                setCrateDetails(data);
                toastr.success('Successfully Update!');
                vm.isLoading = false;
            }, error => {
                vm.isLoading = false;
                toastr.error(error, "Error");
            });
        }

        function editMode(index,obj){
            console.log(index)
            vm.crateData[obj][index].viewMode = vm.crateData[obj][index].viewMode ? false : true
        }

        function addFieldsCrates(obj){
            if('cubicWeightRange' === obj){
                console.log(obj)
                vm.crateData[obj].push({
                    min:'',
                    max:'',
                    cubicConversionFactor:'',
                    viewMode:true
                })
                return;
            }
            vm.crateData[obj].push({
                min:'',
                max:'',
                priceIncrement:'',
                viewMode:true
            })
        }

        function removeForm(index,obj){
            vm.crateData[obj].splice(index, 1);
        }

        function createConfig() {
            vm.isLoading = true;
            Carrier.createCratePlywoodConfig(generatePayload(), (data) => {
                vm.crateData = data;
                setCrateDetails(data);
                toastr.success('Successfully Save!')
                vm.isLoading = false;
            }, error => {
                vm.isLoading = false;
                toastr.error(error, "Error");
            });
        }
 
        function generatePayload() {
            if(!vm.crateData.id){
                vm.crateData.dimensionRange.forEach(item=> {
                    delete item.viewMode
                });
                vm.crateData.cubicWeightRange.forEach(item=> {
                    delete item.viewMode
                });
            }

        
            return {
                dimensionRanges:vm.crateData.dimensionRanges,
                cubicWeightRanges: vm.crateData.cubicWeightRanges,
                enabled:vm.crateData.enabled,
                currency: vm.crateData.currency.currencyCode,
                lastDimensionIncrement: vm.crateData.lastDimensionIncrement,
                lastDimensionIncrementPrice : vm.crateData.lastDimensionIncrementPrice,
                lastVolumeIncrement: vm.crateData.lastVolumeIncrement,
                lastVolumeIncrementCubicConversionFactor: vm.crateData.lastVolumeIncrementCubicConversionFactor,
                measureUnit: vm.crateData.measureUnit.short,
                weightUnit : vm.crateData.weightUnit.value
            };
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/carriers/PlywoodConfigModalController.js